import React, { Component } from 'react';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Services from './services';
import Lib from '../../../commons/lib';
import Loader from '../../../commons/loader';
import ProgressButton from '../../../commons/ProgressButton';

class PartnerAdatok extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'LOAD',
      savedTop: false,
      formDisabled: true,
      modifyObj: {},
      modalText: '',
      /*
       *  MODAL CONTROLLERS
       */
      modalMegerosites: false,
      /*
       *  BASE FORM VALUES
       */
      szuletesinev: false,
      partnercsoport: false,
      cim: false,
      szallitasicim: false,
      szamlazasicim: false,
      email: false,
      telefon: false,
      kedvezmeny: false,
      adoazonosito: false,
      adoszam: false,
      kozossegiadoszam: false,
      bankszamla: false,
      /*
       *  EXTENDED FORM VALUES
       */
      szuletesiido: false,
      nem: false,
      nevnap: false,
      tajszam: false,
      megjegyzes: false,
      fajl: false,
      
      modifyButtonLoading: false,
      saveButtonLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateGDPRdata();
      }
    }
  }

  setDisableTop = () => {
    this.setState({ savedTop: true });
  }

  setOpenTop = () => {
    this.setState({ savedTop: false });
  }

  setDisableBottom = () => {
    this.setState({ formDisabled: true });
  }

  setOpenBottom = () => {
    this.setState({ formDisabled: false });
  }

  toggleMegerositoModal = () => {
    this.setState({
      modalMegerosites: !this.state.modalMegerosites
    });
  }

  updateGDPRdata = () => {
    this.setState({ status: 'LOAD' });
    Services.getGDPRprofil((err, res) => {
      if (!err) {
        if (res[0]) {
          this.setState({
            szuletesinev: res[0].szuletesinev,
            azonosito: true,
            nev: true,
            partnercsoport: true,
            cim: res[0].cim,
            szallitasicim: res[0].szallitasicim,
            szamlazasicim: res[0].szamlazasicim,
            email: res[0].email,
            telefon: res[0].telefon,
            kedvezmeny: res[0].kedvezmeny,
            adoazonosito: res[0].adoazonosito,
            bankszamla: res[0].bankszamla,
            szuletesiido: res[0].szuletesiido,
            nem: res[0].nem,
            adoszam: res[0].adoszam,
            kozossegiadoszam: res[0].kozossegiadoszam,
            nevnap: res[0].nevnap,
            tajszam: res[0].tajszam,
            megjegyzes: res[0].megjegyzes,
            fajl: res[0].fajl
          });
        }
      }
      this.setState({ status: 'DATA' });
    });
  }

  submitModify = (resultObj) => {
    this.setState({ modifyButtonLoading: true });
    Services.check2modify(resultObj, false, (errCheck2) => {
      if (!errCheck2) {
        this.toggleMegerositoModal();
        this.props.globals.addSuccess('Partner adatok módosítva!');
        this.setState({
          formDisabled: true
        }, () => {
          this.updateGDPRdata();
        });
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  submit = () => {
    let resultObj = {
      szuletesinev: this.state.szuletesinev,
      partnercsoport: this.state.partnercsoport,
      cim: this.state.cim,
      szallitasicim: this.state.szallitasicim,
      szamlazasicim: this.state.szamlazasicim,
      email: this.state.email,
      telefon: this.state.telefon,
      kedvezmeny: this.state.kedvezmeny,
      adoazonosito: this.state.adoazonosito,
      adoszam: this.state.adoszam,
      kozossegiadoszam: this.state.kozossegiadoszam,
      bankszamla: this.state.bankszamla,
      szuletesiido: this.state.szuletesiido,
      nem: this.state.nem,
      nevnap: this.state.nevnap,
      tajszam: this.state.tajszam,
      megjegyzes: this.state.megjegyzes,
      fajl: this.state.fajl,
    };
    this.setState({ saveButtonLoading: true });
    Services.check1(resultObj, (errCheck1) => {
      if (!errCheck1) {
        Services.check2modify(resultObj, true, (errCheck2, res2) => {
          if (!errCheck2) {
            if (res2[0].length > 0) {
              this.setState({
                modifyObj: resultObj,
                modalText: res2[0]
              });
              this.toggleMegerositoModal();
            } else {
              this.props.globals.addSuccess('Partner adatok módosítva!');
              this.setState({
                formDisabled: true
              }, () => {
                this.updateGDPRdata();
              });
            }
          }
          this.setState({ saveButtonLoading: false });
        });
      }else{
        this.setState({ saveButtonLoading: false });
      }
    });
  }

  backClick = () => {
    this.updateGDPRdata();
    this.setState({
      formDisabled: true
    });
  }

  renderTopEditBottom = () => {
    return this.state.savedTop ? (
      <Button
        type="button"
        color="success"
        onClick={this.setOpenTop}
      >
        Módosítás
      </Button>
    ) : '';
  }

  renderBottomEditBottom = () => {
    return this.state.formDisabled ? (
      <ProgressButton
        type="button"
        color="success"
        onClick={this.setOpenBottom}
        style={{ marginTop: 10 }}
        loading={this.state.saveButtonLoading}
      >
        Módosítás
      </ProgressButton>
    ) : '';
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  renderBottomSaveBottom = () => {
    return this.state.formDisabled ? '' : (
      <React.Fragment>
        <ProgressButton
          color="primary"
          style={{ marginTop: 10 }}
          loading={this.state.saveButtonLoading}
        >
          Mentés
        </ProgressButton>
        {' '}
        <Button
          color="seccondary"
          type="button"
          style={{ marginTop: 10 }}
          onClick={this.backClick}
        >
          Mégsem
        </Button>
      </React.Fragment>
    );
  }

  renderData = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };
    return (
      <RFForm onSubmit={this.submit}>
        <div className="row">
          <div className="col-md-12">
            <div>
              <h5 style={titleStyle}>
                Kötelező adatok:
              </h5>
            </div>
            <div style={{ paddingLeft: 0 }}>
              <RFField
                label="Azonosító"
                type="checkbox"
                name="azonosito"
                disabled
                value={this.state.azonosito}
              />
              <RFField
                label="Név"
                type="checkbox"
                name="nev"
                disabled
                value={this.state.nev}
              />
              <RFField
                label="Csoport"
                type="checkbox"
                name="partnercsoport"
                disabled
                value={this.state.partnercsoport}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div>
              <h5 style={titleStyle}>
                Alap adatok:
              </h5>
            </div>
            <div style={{ paddingLeft: 0 }}>
              <RFField
                label="Születési név"
                type="checkbox"
                name="szuletesinev"
                disabled={this.state.formDisabled}
                onChange={this.handleInputChange}
                checked={this.state.szuletesinev}
              />
              <RFField
                label="Hivatalos cím"
                type="checkbox"
                name="cim"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.cim}
              />
              <RFField
                label="Szállítási cím"
                type="checkbox"
                name="szallitasicim"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.szallitasicim}
              />
              <RFField
                label="Levelezési cím"
                type="checkbox"
                name="szamlazasicim"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.szamlazasicim}
              />
              <RFField
                label="E-mail"
                type="checkbox"
                name="email"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.email}
              />
              <RFField
                label="Telefonszám(ok)"
                type="checkbox"
                name="telefon"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.telefon}
              />
              <RFField
                label="Kedvezmény (%)"
                type="checkbox"
                name="kedvezmeny"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.kedvezmeny}
              />
              <RFField
                label="Adóazonosító jel"
                type="checkbox"
                name="adoazonosito"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.adoazonosito}
              />
              <RFField
                label="Adószám"
                type="checkbox"
                name="adoszam"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.adoszam}
              />
              <RFField
                label="Közösségi adószám"
                type="checkbox"
                name="kozossegiadoszam"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.kozossegiadoszam}
              />
              <RFField
                label="Bank adatok"
                type="checkbox"
                name="bankszamla"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.bankszamla}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div>
              <h5 style={titleStyle}>
                Kiegészító adatok:
              </h5>
            </div>
            <div style={{ paddingLeft: 0 }}>
              <RFField
                label="Születési idő"
                type="checkbox"
                name="szuletesiido"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.szuletesiido}
              />
              <RFField
                label="Neme"
                type="checkbox"
                name="nem"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.nem}
              />
              <RFField
                label="Névnap"
                type="checkbox"
                name="nevnap"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.nevnap}
              />
              <RFField
                label="TAJ szám"
                type="checkbox"
                name="tajszam"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.tajszam}
              />
              <RFField
                label="Megjegyzés"
                type="checkbox"
                name="megjegyzes"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.megjegyzes}
              />
              <RFField
                label="Fájlkezelés"
                type="checkbox"
                name="fajl"
                onChange={this.handleInputChange}
                disabled={this.state.formDisabled}
                value={this.state.fajl}
              />
            </div>
          </div>
        </div>
        {this.props.globals.hasRole(['GDPR_PROFIL'], true) &&
          this.renderBottomEditBottom()
        }
        {this.props.globals.hasRole(['GDPR_PROFIL'], true) &&
          this.renderBottomSaveBottom()
        }
      </RFForm>
    );
  }

  render() {
    return (
      <>
        {{
          LOAD: (<Loader />),
          DATA: (this.renderData())
        }[this.state.status]}
        <Modal
          isOpen={this.state.modalMegerosites}
          toggle={this.toggleMegerositoModal}
          className={this.props.className}
          backdrop="static"
        >
          <ModalHeader>
            Megerősítés
          </ModalHeader>
          <ModalBody>
            {this.state.modalText}
          </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              loading={this.state.modifyButtonLoading}
              onClick={() => this.submitModify(this.state.modifyObj)}
            >
              Igen
            </ProgressButton>
            <Button
              className="btn-cursor-pointer"
              type="button"
              color="secondary"
              onClick={this.toggleMegerositoModal}
            >
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default PartnerAdatok;
